// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
    background: #dadada;
}
/* @media screen and (max-width: 730px) {
    .container-fluid {
        margin-top: 20px;
    }
} */`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;;;;GAIG","sourcesContent":[".content {\n    background: #dadada;\n}\n/* @media screen and (max-width: 730px) {\n    .container-fluid {\n        margin-top: 20px;\n    }\n} */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
